
import img1 from "../../assets/img/imagination/p1.jpg";
import img2 from "../../assets/img/imagination/polani2.jpg"
import img3 from "../../assets/img/imagination/polani3.jpg"
import img4 from "../../assets/img/imagination/polani4.jpg"
import img5 from "../../assets/img/imagination/polani5.jpg"
import img6 from "../../assets/img/imagination/polani7.png"

// import img8 from "../../assets/img/imagination/polani17.png"
import img9 from "../../assets/img/imagination/polani8.jpg"
import img10 from "../../assets/img/imagination/polani9.jpg"
import img18 from "../../assets/img/imagination/polani10.jpg"
import img11 from "../../assets/img/imagination/polani11.jpg"
import img12 from "../../assets/img/imagination/polani12.jpg"
import img13 from "../../assets/img/imagination/polani3.jpg"
// import img14 from "../../assets/img/imagination/polani14.jpg"
import img15 from "../../assets/img/imagination/polani15.jpg"
import img16 from "../../assets/img/imagination/polani16.jpg"
// import img17 from "../../assets/img/imagination/polani17.jpg"

export const MediaDataa = [
  {
    img: img2,
    // heading: "Corporate Travel",
    // span: "Read More",
  },
  {
    img: img3,
    // heading: "Worldwide Visa ",
    // span: "Read More",
  },
  {
    img: img4,
    // heading: "Holidays and Leisure ",
    // span: "Read More",
  },
  {
    img: img5,
    // heading: "Holidays and Leisure ",
    // span: "Read More",
  },
  {
    img: img6,
    // heading: "Worldwide Visa ",
    // span: "Read More",
  },
 
  {
    img: img11,
    // heading: "Holidays and Leisure ",
    // span: "Read More",
  },
  {
    img: img9,
    // heading: "Holidays and Leisure ",
    // span: "Read More",
  },
  {
    img: img12,
    // heading: "Worldwide Visa ",
    // span: "Read More",
  },
 
  {
    img: img15,
    // heading: "Holidays and Leisure ",
    // span: "Read More",
  },
  {
    img: img16,
    // heading: "Holidays and Leisure ",
    // span: "Read More",
  },
];
